export default __webpack_public_path__ + "locales/ko-KR/Common.json?hash=04c8dc8901fb4ab4ada20026d8a55831";